// extracted by mini-css-extract-plugin
export default {"topBar":"GeneralJobCard_topBar__8Wu8M","titleBlock":"GeneralJobCard_titleBlock__LQhrx","actionBar":"GeneralJobCard_actionBar__QF7Fk","subBar":"GeneralJobCard_subBar__f6loR"};